var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uk-flex"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"body uk-width-expand"},_vm._l((_vm.requests),function(req){return _c('request',{key:req.id,attrs:{"request":req.request}})}),1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('i',{staticClass:"material-icons"},[_vm._v("comment")]),_vm._v("\n        검수 요청사항\n    ")])
}]

export { render, staticRenderFns }